import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import styles from './contacto.module.css';

const Contacto = () => {
const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
});
const [isSubmitting, setIsSubmitting] = useState(false);
const [submitStatus, setSubmitStatus] = useState('');

const handleChange = (e) => {
    setFormData({
    ...formData,
    [e.target.name]: e.target.value
    });
};

const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
    await emailjs.send(
        'service_nv6vyrd',
        'template_avuzmlf',
        {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        time: new Date().toLocaleString(),
        to_email: 'LautaroMazzaTango@gmail.com'
        },
        'IqblEgv2l5XA0yE-I'
    );
    
    setSubmitStatus('success');
    setFormData({ name: '', email: '', message: '' });
    } catch (error) {
    console.error('Error sending email:', error);
    setSubmitStatus('error');
    } finally {
    setIsSubmitting(false);
    setTimeout(() => setSubmitStatus(''), 3000);
    }
};

return (
    
    <div className={styles.container}>
    <h2 className={styles.title}>Contact</h2>
    <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
        <label htmlFor="name" className={styles.label}>Name:</label>
        <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={styles.input}
            required
        />
        </div>
        
        <div className={styles.formGroup}>
        <label htmlFor="email" className={styles.label}>Email:</label>
        <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={styles.input}
            required
        />
        </div>
        
        <div className={styles.formGroup}>
        <label htmlFor="message" className={styles.label}>Message:</label>
        <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            className={styles.textarea}
            required
        />
        </div>
        
        <button 
        type="submit" 
        disabled={isSubmitting}
        className={`${styles.submitBtn} ${isSubmitting ? styles.submitting : ''}`}
        >
        {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
        
        {submitStatus === 'success' && (
        <div className={styles.successMessage}>
            <span className={styles.checkmark}>&#10003;</span>
            Message Sent
        </div>
        )}
        
        {submitStatus === 'error' && (
        <div className={styles.errorMessage}>
            <span className={styles.exclamation}>&#33;</span>
            Please try again.
        </div>
        )}
    </form>
    </div>
);
};

export default Contacto;